import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { BootstrapService } from '@services/bootstrap.service';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
  private readonly translateService = inject(TranslateService);
  private readonly title = inject(Title);
  private readonly bootstrap = inject(BootstrapService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    super();
  }

  /**
   * Sets the tab title on every navigation, combining the route title with the
   * tenant display name as `Route | Tenant`. This strategy is the single owner
   * of `document.title` — BootstrapService intentionally does not write it, so
   * the tenant branding survives the first (and every) navigation.
   */
  override updateTitle(snapshot: RouterStateSnapshot) {
    const routeTitle = this.buildTitle(snapshot);
    const tenant = this.bootstrap.displayName();

    if (routeTitle) {
      this.translateService.get(routeTitle).subscribe((translatedTitle) => {
        this.title.setTitle(`${translatedTitle} | ${tenant}`);
      });
    } else {
      this.title.setTitle(tenant);
    }
  }
}
